export default function WhatYouGet() {
  const benefits = [
    {
      icon: 'ri-calendar-check-line',
      title: 'Cycle Clarity Tracker',
      description: 'Notion / Google Sheets'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Symptom-to-Insight Decoder',
      description: 'Understand what your body is telling you'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Fertile Window Confidence Framework',
      description: 'Know exactly when you\'re most fertile'
    },
    {
      icon: 'ri-time-line',
      title: '7-Day Guided Setup',
      description: 'No overwhelm, just simple steps'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Plain-English Explanations',
      description: 'No medical jargon, just clarity'
    }
  ];

  return (
    <section id="what-you-get" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What You Get
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Simple, Tangible, Valuable
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/af84490e484a32258481d5416d7d609f/b6356a62829a0374a48543fc687b4f2a.jpeg"
                alt="Cycle Clarity Starter Kit Contents"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Benefits List */}
          <div className="order-1 lg:order-2 space-y-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start gap-4 bg-violet-50 rounded-2xl p-6 hover:bg-violet-100 transition-colors"
              >
                <div className="flex-shrink-0 w-12 h-12 bg-violet-600 rounded-full flex items-center justify-center">
                  <i className={`${benefit.icon} text-white text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">
                    ✔ {benefit.title}
                  </h3>
                  <p className="text-gray-600">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="https://payhip.com/b/EvcbM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-violet-600 text-white px-12 py-4 rounded-full text-lg font-semibold hover:bg-violet-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Your Starter Kit Now
          </a>
        </div>
      </div>
    </section>
  );
}